const coursetemplates = {
	title: "Kursmaler",
	new_coursetemplate: "Ny kursmal",
	edit_coursetemplate: "Rediger kursmal: {name}",
	view_coursetemplate: "Vis kursmal: {name}",
	list_title: "Kursmaler",
	list_subtitle: "Håndtere kursmaler",
	create_title: "Ny kursmal",
	update_title: "Endre kursmal",
	address_title: "Addresse",
	details_title: "Kursmal detaljer",
	id: "ID",
	name: "Navn",
	certificate_display_name: "Kompetansebevis visningsnavn",
	short_description: "Kort beskrivelse",
	long_description: "Lang beskrivelse",
	coursetemplatetype_id: "Type",
	pdf_template: "PDF mal",
	pdf_title: "PDF Tittel",
	pdf_description: "PDF Beskrivelse",
	pdf_description_hint: " ",
	pdf_content: "PDF Innhold",
	info_link: "Info Link",
	type: "Type",
	price: "Pris",
	price_proof: "Pris for bevis",
	price_vat: "Pris m/MVA",
	valid_for: "Gyldig i",
	status: "Status",
	created_by: "Opprettet av",
	coursetypegroup_id: "Kursgruppe",
	duplicate_message: "Vil du opprette en kopi av valgt mal?",
	upload_pdf_template: "Last opp mal",
	select_pdf_template: "Velg PDF",
	preview_pdf_template: "Forhåndsvisning",
	months: "måneder",
	valid_for_helptext: "La stå tomt for ingen utløpsdato, ellers vil utløpsdatoen bli beregnet fra utstedelsesdatoen.",
	enrolment_preview: "Forhåndsvisning av påmeldingsskjema",
	select_template_type: "Velg kursmaltype (Kan ikke endres!)",
	type_normal_helptext: " ",
	type_long_helptext: " ",
};
export default coursetemplates;